export const ROWS_PERPAGE_OPTIONS = [15, 25, 50];
export const DEFAULT_PER_PAGE = 25;
export const DEFAULT_IMPRESSIONS_PERIOD = '30';
